import React, { useState } from 'react';
import { useDraggableSheet } from '../../../helpers/hooks';
import './UpdateOrder.scss';

const UpdateOrder = ({ order_id, onClose, onSubmit }) => {
    const { sheetStyle, overlayHandlers } = useDraggableSheet({ onClose });
    const [carrier, setCarrier] = useState('');
    const [tracking, setTracking] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (onSubmit) onSubmit('shipped', order_id, carrier, tracking );
    };

    return (
        <div className="update-order">
            <div className="overlay" {...overlayHandlers}></div>
            <div className="sheet py-24" style={sheetStyle} onClick={(e) => e.stopPropagation()}>
                <p className='fg-dark fs-regular fw-bold ta-center'>Update order</p>
                <form className="form" onSubmit={handleSubmit}>
                    <div className="field">
                        <input
                            type="text"
                            placeholder="Carrier number"
                            value={carrier}
                            onChange={e => setCarrier(e.target.value)}
                            className="input"
                        />
                    </div>
                    <div className="field">
                        <input
                            type="text"
                            placeholder="Tracking number"
                            value={tracking}
                            onChange={e => setTracking(e.target.value)}
                            className="input"
                        />
                    </div>
                    <button type="submit" className="btn-shipped" onClick={handleSubmit}>
                        Mark as Shipped
                    </button>
                </form>
            </div>
        </div>
    );
};

export default UpdateOrder;